import { completeNum } from '@/utils/index'


function dataURLtoBlob (dataurl) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

function blobToFile (theBlob, fileName) {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}

export function base64ToFile (dataUrl, name) {
  const blob = dataURLtoBlob(dataUrl)
  const file = blobToFile(blob, name)
  return file
}

export function fileSuffix (filename) {
  const pos = filename.lastIndexOf('.')
  let suffix = ''
  if (pos !== -1) {
    suffix = filename.substring(pos)
  }
  return suffix
}

export function randomFilename (filename) {
  const suffix = fileSuffix(filename)
  const now = new Date()

  const randint = Math.floor(Math.random() * 1000)
  const newFilename = completeNum(now.getHours(), 2) +
                      completeNum(now.getMinutes(), 2) +
                      completeNum(now.getSeconds(), 2) +
                      completeNum(randint, 4) +
                      suffix
  return newFilename
}

export function getUploadParams (ossToken, fileObj) {
  const filename = randomFilename(fileObj.name)

  let formData = new FormData()
  formData.append('key', ossToken.dir + filename)
  formData.append('policy', ossToken.policy)
  formData.append('OSSAccessKeyId', ossToken.accessid)
  formData.append('success_action_status', '200')
  // formData.append('callback', ossToken.callback)
  formData.append('signature', ossToken.signature)

  formData.append('name', fileObj.name)
  formData.append('file', fileObj)

  return formData
}
